import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizedTextEditorComponent } from '@shared/components/localized-text-editor/localized-text-editor.component';
import type { SeoForm } from '../water-information-form.types';

@Component({
  selector: 'app-water-information-seo-section',
  templateUrl: './water-information-seo-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatCardModule, TranslatePipe, LocalizedTextEditorComponent],
})
export class WaterInformationSeoSectionComponent {
  @Input({ required: true }) form!: FormGroup<SeoForm>;
}
